import { combineReducers, Reducer } from 'redux';

import * as types from './users.types';
import * as constants from './users.constants';
import { isActionOfType } from '../../../../utils/action.utils';

import { userFormReducer } from './user-form/user-form.reducer';

const initialState: types.IUsersPagePureState = {
  activeUserIds: [],
  deletedUserIds: [],
  isFetched: false,
  createUserSuccess: false,
  addUserToTenantSuccess: false,
  userExistenceCheck: null,
};

const activeUserIdsReducer: Reducer<
  types.IUsersPagePureState['activeUserIds'],
  types.IStoreFetchedActiveUsers | types.IClearFetchedActiveUsers
> = (state = initialState.activeUserIds, action) => {
  if (isActionOfType<types.IStoreFetchedActiveUsers>(action, constants.STORE_FETCHED_ACTIVE_USERS)) {
    return action.payload;
  } else if (isActionOfType<types.IClearFetchedActiveUsers>(action, constants.CLEAR_FETCHED_ACTIVE_USERS)) {
    return initialState.activeUserIds;
  }
  return state;
};

const deletedUserIdsReducer: Reducer<
  types.IUsersPagePureState['deletedUserIds'],
  types.IStoreFetchedDeletedUsers | types.IClearFetchedDeletedUsers
> = (state = initialState.deletedUserIds, action) => {
  if (isActionOfType<types.IStoreFetchedDeletedUsers>(action, constants.STORE_FETCHED_DELETED_USERS)) {
    return action.payload;
  } else if (isActionOfType<types.IClearFetchedDeletedUsers>(action, constants.CLEAR_FETCHED_DELETED_USERS)) {
    return initialState.deletedUserIds;
  }
  return state;
};

const isFetchedReducer: Reducer<
  types.IUsersPagePureState['isFetched'],
  types.IStoreIsFetched | types.IClearIsFetched
> = (state = initialState.isFetched, action) => {
  if (isActionOfType<types.IStoreIsFetched>(action, constants.STORE_IS_FETCHED)) {
    return true;
  } else if (isActionOfType<types.IClearIsFetched>(action, constants.CLEAR_IS_FETCHED)) {
    return initialState.isFetched;
  }
  return state;
};

const createUserSuccessReducer: Reducer<
  types.IUsersPagePureState['createUserSuccess'],
  types.ICreateUserSuccess | types.IClearCreateUserSuccess
> = (state = initialState.createUserSuccess, action) => {
  if (isActionOfType<types.ICreateUserSuccess>(action, constants.CREATE_USER_SUCCESS)) {
    return true;
  } else if (isActionOfType<types.IClearCreateUserSuccess>(action, constants.CLEAR_CREATE_USER_SUCCESS)) {
    return false;
  }
  return state;
};

const addUserToTenantSuccessReducer: Reducer<
  types.IUsersPagePureState['addUserToTenantSuccess'],
  types.IAddUserToTenantSuccess | types.IClearAddUserToTenantSuccess
> = (state = initialState.addUserToTenantSuccess, action) => {
  if (isActionOfType<types.IAddUserToTenantSuccess>(action, constants.ADD_USER_TO_TENANT_SUCCESS)) {
    return true;
  } else if (isActionOfType<types.IClearAddUserToTenantSuccess>(action, constants.CLEAR_ADD_USER_TO_TENANT_SUCCESS)) {
    return false;
  }
  return state;
};

const userExistenceCheckReducer: Reducer<
  types.IUsersPagePureState['userExistenceCheck'],
  types.IStoreUserExistenceCheck | types.IClearUserExistenceCheck
> = (state = initialState.userExistenceCheck, action) => {
  if (isActionOfType<types.IStoreUserExistenceCheck>(action, constants.STORE_USER_EXISTENCE_CHECK)) {
    return action.payload;
  } else if (isActionOfType<types.IClearUserExistenceCheck>(action, constants.CLEAR_USER_EXISTENCE_CHECK)) {
    return null;
  }
  return state;
};

export const usersPageReducer: Reducer<types.IUsersPageState, types.IUsersPageAction> = combineReducers({
  activeUserIds: activeUserIdsReducer,
  deletedUserIds: deletedUserIdsReducer,
  isFetched: isFetchedReducer,
  createUserSuccess: createUserSuccessReducer,
  addUserToTenantSuccess: addUserToTenantSuccessReducer,
  userExistenceCheck: userExistenceCheckReducer,
  userForm: userFormReducer,
});
